export default class StartMessageNotificationCtrl{

  constructor($scope,GeneralSettingsSrv,$stateParams,$mdDialog){
    var startMessageVm = this

    startMessageVm.message = {}
    startMessageVm.showInputDates = false
    startMessageVm.message.startDate = null
    startMessageVm.message.endDate = null
    startMessageVm.saveButtonDisabled = false;
    startMessageVm.message.isUndefined = true
    startMessageVm.minDate= new Date()

    startMessageVm.scheduleNotificationTypeSelected = scheduleNotificationTypeSelected
    startMessageVm.saveStartMessage = saveStartMessage
    startMessageVm.hasError = hasError
    startMessageVm.showErrorMessages = showErrorMessages
    startMessageVm.validateForm = validateForm
    startMessageVm.isDateRequired = isDateRequired
    startMessageVm.startDateChanged = startDateChanged
    var editingNotification = false

    activate()

    function activate() {
      return getScheduleNotificationType()
      .then(function (){
        if($stateParams.notificationId){
          editingNotification = true
          getNotification($stateParams.notificationId)
        }
      })
    }

    function getScheduleNotificationType() {

      return GeneralSettingsSrv.scheduleNotificationType.getList()
      .$promise.then(function(dataReturn) {
        if(dataReturn.status == true){
          startMessageVm.schedules = dataReturn.data
          startMessageVm.message.scheduleNotificationTypeId = startMessageVm.schedules[ 1 ].scheduleNotificationTypeId
        }else{
         console.log(dataReturn)
        }
      },function(data) {
       console.log(data)
      });
    }

    function getNotification(notificationId) {
      return GeneralSettingsSrv.getNotificationById.get({notificationId: notificationId})
      .$promise.then(function(dataReturn) {
        if( dataReturn.status == true ){
          if( dataReturn.data )
            startMessageVm.message = formatNotification( dataReturn.data[0] )
        }
        else{}

        },function(data) {
          console.log(data)
      })
    }

    function scheduleNotificationTypeSelected(scheduleName){
      if(scheduleName.toLowerCase().indexOf("indefinido") >= 0){
        startMessageVm.showInputDates = false
        startMessageVm.message.isUndefined = true
        startMessageVm.message.startDate = null
        startMessageVm.message.endDate = null
      }
      else{
        startMessageVm.showInputDates = true
        startMessageVm.message.isUndefined = false
      }
    }

    function saveStartMessage(){
      startMessageVm.saveButtonDisabled = true;
      if(startMessageVm.showInputDates){
        startMessageVm.message.startDate = new Date(startMessageVm.message.startDate)
        startMessageVm.message.endDate = new Date(startMessageVm.message.endDate)
        startMessageVm.message.isUndefined = false
      }
      else{
        startMessageVm.message.startDate = null
        startMessageVm.message.endDate = null
        startMessageVm.message.isUndefined = true
      }
      if(!editingNotification)
        save(startMessageVm.message)
      else
        edit(formatNotificationToEdit(startMessageVm.message))
    }

    function hasError(input){
      if( input.$invalid && (input.$dirty || input.$touched ) )
        return 'has-error';
    }

    function showErrorMessages(input)
    {
      return input.$dirty || input.$touched;
    }

    function validateForm(form){
        return form.$invalid;
    }

    function isDateRequired() {
      return startMessageVm.message.scheduleNotificationTypeId == startMessageVm.schedules[ 0 ].scheduleNotificationTypeId
    }

    function startDateChanged() {
      let m = moment( startMessageVm.message.startDate );
      startMessageVm.minEndDate = m.isValid() ? m.add(1, 'days').toDate() : null;
    }

    function showModalStartMessageCreated(){
      let startMessageName = startMessageVm.message.asunto;
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.startMessageName = startMessageName;
          $scope.close = function() {
            $mdDialog.hide();
          }
        }],
        template: require('./modalStartMessageCreated.html'),
        clickOutsideToClose:false
      });
    }

    function formatNotification (notification) {
      if(notification.ds_name)
        notification.dsName = notification.ds_name
      if(notification.ds_description)
        notification.dsDescription = notification.ds_description
      if(notification.id_schedule_notification_type)
        notification.scheduleNotificationTypeId = notification.id_schedule_notification_type
      if(notification.start_date && moment(notification.start_date).isValid()
        && notification.end_date && moment(notification.end_date).isValid()){
        notification.startDate = moment(notification.start_date, 'YYYY-MM-DD').toDate()
        notification.endDate = moment(notification.end_date, 'YYYY-MM-DD').toDate()
        startMessageVm.message.isUndefined = false
        startMessageVm.showInputDates = true
      }
      else{
        startMessageVm.message.isUndefined = true
        startMessageVm.showInputDates = false
      }
      if(notification.id_code)
        notification.idCode = notification.id_code

      return notification
    }

    function formatNotificationToEdit(notification) {
      notification.ds_name = notification.dsName
      notification.ds_description = notification.dsDescription
      notification.id_schedule_notification_type = notification.scheduleNotificationTypeId
      notification.id_notification = notification.idCode
      notification.is_undefined = notification.isUndefined
      notification.id_notification = notification.id_code
      if(!notification.isUndefined){
        notification.start_date = new Date(notification.startDate)
        notification.end_date = new Date(notification.endDate)
      }
      else{
        notification.start_date = null
        notification.end_date = null
      }
      return notification
    }

    function save(message){
      GeneralSettingsSrv.createStartMessage.save({message : message})
      .$promise.then(function(dataReturn) {
        if(dataReturn.status == true){
          showModalStartMessageCreated()
        }else{
          startMessageVm.saveButtonDisabled = false;
         console.log(dataReturn)
        }
      },function(data) {
        startMessageVm.saveButtonDisabled = false;
       console.log(data)
      });
    }

    function edit(message){
      GeneralSettingsSrv.updateNotification.update(message)
      .$promise.then(function(dataReturn) {
        if(dataReturn.status == true){
          showModalStartMessageCreated()
        }else{
          startMessageVm.saveButtonDisabled = false;
          console.log(dataReturn)
        }
      },function(data) {
        startMessageVm.saveButtonDisabled = false;
        console.log(data)
      });
    }

  }// FIN DEL CONSTRUCTOR

      preventInput(event){
      var  vKey = 86
      if (event.keyCode == vKey)
        event.preventDefault()
      return;
    }
}

StartMessageNotificationCtrl.$inject = ['$scope','GeneralSettingsSrv','$stateParams','$mdDialog']


// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/notifications/startMessage/startMessageNotificationCtrl.js